import { render, staticRenderFns } from "./fund.vue?vue&type=template&id=132604ae&scoped=true&"
var script = {}
import style0 from "./fund.vue?vue&type=style&index=0&id=132604ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132604ae",
  null
  
)

export default component.exports